export default (state = {}, { type, payload }) => {
  switch (type) {

    case 'SET_INNER_MENU':
      return payload

    default:
      return state
  }
}
